import React, { Component } from "react";
import { Elements, StripeProvider, CardElement } from "react-stripe-elements";
import { loadStripe } from "@stripe/stripe-js";
import Header from "./components/header.js";
import Footer from "./components/footer.js";
import Donate from "./components/donate.js";
import DonationOptions from "./components/donation-options.js";
import LearnMoreButton from "./components/learn-more.js";
import SocialComponent from "./components/social-component.js";
import Checkout from "./pages/page-donate.js";
import { Link, withRouter } from "react-router-dom";
import heroImage from "./images/hero_image.png";
import "./App.scss";
const data = require("./data/data.json");

class App extends Component {
  renderBody = () => {
    return (
      <div>
        {data.body.map((paragraph) => {
          return <p>{paragraph}</p>;
        })}
      </div>
    );
  };

  render() {
    return (
      <div>
        <Header />
        <div className="topTitle">
          <h1>{data.title}</h1>
        </div>
        <div className="row">
          <div className="double-column">
            <div className="column">
              <div className="section-main">
                <div className="section-main-title">
                  <img src={heroImage}></img>
                  <div style={{ minWidth: "300px" }}></div>
                </div>

                <div className="section-main-description">
                  <p>
                    <b>Total Raised and Donated to Date: $358,016!!!!</b>
                  </p>
                  <p>
                  While we lost Donna in 2021 after a courageous battle with cancer, her lasting legacies include   
                  her beautiful heart; her thoughtfulness and concern for others, and her willingness to take   
                  action to help. She was simply always thinking of other people.  
                  </p>
                  <p>
                  With this in mind, in 2022, we established the Donna V. Toelke Charitable Foundation. Our   
                  mission is to raise money every year from Donna’s vast network of family, friends and others   
                  who share her incredible charitable spirit, and then to immediately deploy our funds to support   
                  causes which were near and dear to her heart. Donna’s charitable giving spanned children’s   
                  causes; education; food insecurity; homelessness and fighting cancer among others. Target   
                  charities will certainly include those working to address some of these issues, although we will   
                  consider all worthy causes. In fact, we invite all contributors to the Foundation to make   
                  recommendations for charities to whom we should consider allocating funds. It’s a team effort!  
                  </p>
                  <p>
                  We kept up the momentum in 2024, and once again raised and distributed over $100,000 to   
                  several amazing organizations. In less than three years, the Foundation has contributed over   
                  $350,000 in Donna’s name to non-profits who are utilizing this money to make a meaningful   
                  difference in the lives of those in need. Well done, all!!!!  
                  </p>
                  <p>
                  The following are a list of last year’s recipient organizations:
                  </p>

                  <div className="section-main-description-center-text">
                    <p>
                      <a
                        href="https://www.silverliningmentoring.org/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Silver Lining Mentoring - Fostering Bright Futures
                      </a>
                    </p>

                    <p>
                      <a
                        href="https://fresh-truck-org.myshopify.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Fresh Truck
                      </a>
                    </p>

                    <p>
                      <a
                        href="https://projectplace.org/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        End Homelessness With Us - Project Place
                      </a>
                    </p>

                    <p>
                      <a
                        href="https://www.breaktime.org/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Breaktime | Ending Young Adult Homelessness | Massachusetts
                      </a>
                    </p>

                    <p>
                      <a
                        href="https://familyaidboston.org/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Home - FamilyAid
                      </a>
                    </p>

                    <p>
                      <a
                        href="https://womenslunchplace.org/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Woburn Food Pantry
                      </a>
                    </p>
                  </div>

                  <p>
                  Donna did not want to be forgotten, and we feel that this continues to be a beautiful and fitting   
                  way to always remember Donna and keep her in our minds and hearts as we emulate her by   
                  working to make the world a better place and easing the burden on those less fortunate. Thank   
                  you so much for joining us and becoming part of the Foundation’s mission.
                  </p>
                  <p>
                  The Foundation has been established as a 501(c)(3) organization, so that each person who   
                  contributes to the Foundation will be entitled to a charitable deduction upon making his or her   
                  contribution. Please also consider adding a matching donation through your employer.  
                  </p>
                  <p>Rich, Richie, Sam and Margaret</p>
                  <br />
                </div>
              </div>
            </div>
          </div>

          <div className="column">
            <div className="section-donate">
              <Donate />
              <DonationOptions />
              <SocialComponent />
              <div class="section-donate-disclaimer">
                *While we work to ensure accuracy, the stats indicated on this
                page may not be an exact reflection of actual activity.
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(App);
